module.exports = __webpack_public_path__ + "static/media/custom_map.e96eb480.mp4";